import { render, staticRenderFns } from "./BrandComponentSpec.vue?vue&type=template&id=559c811d&scoped=true"
import script from "./BrandComponentSpec.vue?vue&type=script&lang=js"
export * from "./BrandComponentSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c811d",
  null
  
)

export default component.exports